import { render, staticRenderFns } from "./PrescriptionFilter.vue?vue&type=template&id=2bf26507&"
import script from "./PrescriptionFilter.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionFilter.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionFilter.vue?vue&type=style&index=0&id=2bf26507&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports